export default "__VITE_ASSET__B231tCXy__"